import Lightbox from './Lightbox';
export default Lightbox;
//# sourceMappingURL=index.js.map